import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Modal, Image, Header, Select, Button } from "semantic-ui-react";
import ModalImage from "../../components/Images/card.png";
// import { withRouter } from "react-router-dom";
import { openModal } from "../../features/modals/modalActions";
import { closeModal } from "../../features/modals/modalActions";

const actions = {
    openModal,
    closeModal
};

class TestSelectionModal extends Component {
    numbers = [
        { key: "twenty", value: 20, text: "Model of 20" },
        { key: "fifty", value: 50, text: "Model of 50" },
        { key: "Hundred", value: 100, text: "Model of 100" }
    ];
    selectedTopic = "";
    routeParamValue = "";
    isRouteParamValueSet = false;

    handleModelChange = (event, data) => {
        console.log("handle model change called");
        this.routeParamValue = this.selectedTopic + " " + data.value;
        this.isRouteParamValueSet = true;
        console.log(
            "isRouteParamValueSet ",
            this.isRouteParamValueSet ? "Yes" : "No"
        );
    };

    redirectToTestPage = () => {
        if (this.isRouteParamValueSet) {
            this.props.history.push({
                pathname: "/test",
                query: { value: this.routeParamValue }
            });

            this.isRouteParamValueSet = false;
        }
    };

    render() {
        const { subject } = this.props;
        this.selectedTopic = subject;
        console.log("im in TestSelctionModal", this.props);
        return (
            <div>
                <Modal open={true} onClose={this.props.openModal.close}>
                    <Modal.Header />
                    <Modal.Content image>
                        <Image wrapped size="small" src={ModalImage} />
                        <Modal.Description>
                            <Header>{subject}</Header>
                            <p>
                                Lorem ipsum dolor sit amet consectetur
                                adipisicing elit. Accusamus, nemo quae eveniet
                            </p>
                            <Select
                                placeholder="Select your number"
                                options={this.numbers}
                                onChange={this.handleModelChange}
                            />
                            {!this.isRouteParamValueSet && (
                                <p style={{ color: "red" }}>
                                    Please select first
                                </p>
                            )}
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            color="red"
                            onClick={this.props.openModal.close}
                        >
                            Cancel
                        </Button>
                        <Button
                            positive
                            icon="checkmark"
                            labelPosition="right"
                            content="Okay"
                            onClick={this.redirectToTestPage}
                        />
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

export default withRouter(
    connect(
        null,
        actions
    )(TestSelectionModal)
);
